import apiClient from '@/services/axios'
import { transformIntoQuery } from '@/utils/pagination'
import ReportService from '@/services/api/admin/reports/excel-report-services'

class ProductService {
  constructor() {
    this.$api = apiClient
  }

  getSellerCategories () {
    return this.$api.get('/seller/category')
  }

  /** managing of product offers start region **/

  importFromExcel (payload) {
    const body = new FormData()
    body.append('file', payload)
    return this.$api.post('/seller/company-products/import-from-excel', body, { responseType: 'blob' })
      .then((response) => {
        ReportService.download(response, 'UploadedProducts.xlsx')
      })
  }

  exportProductsToExcel (pagination, filter, sorting, filename) {
    const query = transformIntoQuery(pagination, sorting, filter)
    return this.$api.get(`/seller/company-products/export-to-excel${query}`, { responseType: 'blob' })
      .then((response) => {
        ReportService.download(response, filename)
      })
  }

  getProducts (pagination, filter, sorting) {
    const query = transformIntoQuery(pagination, sorting, filter)

    return this.$api.get(`/seller/company-products${query}`)
  }

  getProduct (productId) {
    return this.$api.get(`/seller/products/${productId}`)
  }

  updateProduct (productId, payload) {
    return this.$api.put(`/seller/company-products/${productId}`, payload)
  }

  createProduct (payload) {
    return this.$api.post('/seller/company-products', payload)
  }

  deleteProduct (productId) {
    return this.$api.delete(`/seller/company-products/${productId}`)
  }

  toggleProductActiveness(productId, hide) {
    return this.$api.patch(`/seller/company-products/${productId}?hidden=${hide}`)
  }

  previewProduct (id, isCompanyProduct) {
    if (isCompanyProduct)
      return this.$api.get(`/seller/company-products/preview?company_product_id=${id}`)
    else
      return this.$api.get(`/seller/company-products/preview?variation_id=${id}`)
  }

  /** managing of product offers end region **/

  /** creation of offers start region **/

  getAvailableProducts (pagination, sorting, filters) {
    const query = transformIntoQuery(pagination, sorting, filters)

    return this.$api.get(`/seller/products${query}`)
  }

  getProductVariations (productId) {
    return this.$api.get(`/seller/products/${productId}/product-variations`)
  }

  createOffers (payload) {
    return this.$api.post('/seller/company-products', payload)
  }

  /** creation of offers end region **/

  /** creation of product suggestion start region **/

  postProductSuggestion (payload) {
    return this.$api.post('/seller/suggested-products', payload)
  }

  getStaticAttributes (productId) {
    return this.$api.get(`/seller/suggested-products/${productId}/static-attributes`)
  }

  putStaticAttributes (productId, payload) {
    return this.$api.put(`/seller/suggested-products/${productId}/static-attributes`, payload)
  }

  postSuggestionDescription (productId, payload) {
    return this.$api.put(`/seller/suggested-products/${productId}/descriptions`, payload)
  }

  getProductImages (productId) {
    return this.$api.get(`/seller/suggested-products/${productId}/images`)
  }

  postProductImage (productId, isMain, payload) {
    const body = new FormData()
    body.append('file', payload)
    return this.$api.post(`/seller/suggested-products/${productId}/images?is-main=${isMain}`, body, {})
  }

  deleteProductImage (productId, imageId) {
    return this.$api.delete(`/seller/suggested-products/${productId}/images/${imageId}`)
  }

  setProductMainImage (productId, imageId) {
    const payload = [
      { id: imageId, is_main: true },
    ]

    return this.$api.put(`/seller/suggested-products/${productId}/images`, payload)
  }

  getVariations (productId) {
    return this.$api.get(`/seller/suggested-products/${productId}/variations`)
  }

  createVariation (variation, productId) {
    return this.$api.post(`/seller/suggested-products/${productId}/variations`, variation)
  }

  updateVariation (variation, productId, variationId) {
    return this.$api.put(`/seller/suggested-products/${productId}/variations/${variationId}`, variation)
  }

  updateVariationImages (productId, variationId, imageList) {
    return this.$api.put(`/seller/suggested-products/${productId}/variations/${variationId}/images`, imageList)
  }

  /** creation of product suggestion end region **/
}

export default new ProductService()
